<div class="claims-panel">
  <div>
    <form
      #CommissionForm="ngForm"
      [formGroup]="commissionForm"
      class="form-container"
    >
      <div class="search-row-1">
        <mat-form-field appearance="outline" class="fieldSize1">
          <mat-select
            placeholder="Term *"
            [(ngModel)]="selectedTermOption"
            formControlName="termCtrl"
            (selectionChange)="optionChanged2()"
          >
            <mat-option *ngFor="let term of termList" [value]="term.Name">
              {{ term.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>

    <div class="lineContainer">
      <div class="buttonVAligned">
        <div class="AgencyInfo">
          <span class="label">
            <label>Agency ID:</label>
          </span>
          <span>
            {{ this.agencyID }}
          </span>
          <br />
          <span class="label">
            <label>Agency Name:</label>
          </span>
          <span>
            {{ this.agencyName }}
          </span>
        </div>
      </div>
      <div class="search-bar" id="applications-search">
        <mat-form-field id="dropDownAgentsList" appearance="outline">
          <mat-label>Select All Agents</mat-label>
          <mat-select
            [(value)]="selectedAgentOption"
            (selectionChange)="optionChanged()"
          >
            <mat-option [value]="0" (click)="applyFilter('0')"
              >Select All Agents</mat-option
            >
            <mat-option
              *ngFor="let optionSel of agentsList"
              [value]="optionSel.Agent_Name"
            >
              {{ optionSel.Agent_Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div id="spacer">
          <span> </span>
        </div>

        <mat-form-field appearance="outline" class="search-bar">
          <mat-label>Search list</mat-label>
          <input
            type="text"
            matInput
            #search
            (keyup)="applyFilter($event.target.value)"
            maxlength="256"
            placeholder="Search"
          />
          <mat-icon matSuffix>search</mat-icon>
          <mat-hint>Example: Application #, Student #, Name</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="lineContainer">
    <div class="buttonVAligned">
      <button
        mat-flat-button
        type="button"
        disabled="{{ commissionsLocked }}"
        class="seneca-button"
        color="primary"
        (click)="onSubmitClaim()"
      >
        Submit My Claims
      </button>
    </div>

    <div class="rowExport">
      <div class="alignToRight">
        <span>
          <a (click)="ExportToExcel()"
            >Export to XLS
            <span>
              <img
                id="excelImage"
                src="../../../../../../assets/img/export-excel-48-3.png"
              />
            </span>
          </a>
        </span>
        <span id="spacer"> </span>
        <span>
          <a (click)="ExportToPDF()" class="Seneca-Export-Button"
            >Export to PDF
            <span>
              <img
                id="pdfImage"
                src="../../../../../../assets/img/export-pdf-48-3.png"
              />
            </span>
          </a>
        </span>
      </div>
    </div>
  </div>
  <div *ngIf="commissionsLocked" class="buttonVAligned">
    <p class="commission-locked-alert">{{ commissionsLockedMessage }}</p>
  </div>

  <div class="table-form" #pdfTable>
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      class="mat-elevation-z8"
      multiTemplateDataRows
      (matSortChange)="sortData($event)"
      #content
    >
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
            [disabled]="
              commissionsLocked || row.CommissionStatusName == 'NotEligible'
            "
            [aria-label]="checkboxLabel(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="StudentName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Student Name</th>
        <td mat-cell *matCellDef="let element">{{ element.StudentName }}</td>
      </ng-container>

      <ng-container matColumnDef="SENECA_ID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Student Number
        </th>
        <td mat-cell *matCellDef="let element">{{ element.SENECA_ID }}</td>
      </ng-container>

      <ng-container matColumnDef="ApplicationID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Application Number
        </th>
        <td mat-cell *matCellDef="let element">{{ element.ApplicationID }}</td>
      </ng-container>

      <ng-container matColumnDef="Term">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Term</th>
        <td mat-cell *matCellDef="let element">{{ element.Term }}</td>
      </ng-container>

      <ng-container matColumnDef="AgentName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Agent Name</th>
        <td mat-cell *matCellDef="let element">{{ element.AgentName }}</td>
      </ng-container>

      <ng-container matColumnDef="StatusDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status Date</th>
        <td mat-cell *matCellDef="let element">{{ element.StatusDate }}</td>
      </ng-container>

      <ng-container matColumnDef="TuitionAmount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Tuition Amount
        </th>
        <td mat-cell *matCellDef="let element">
          $ CAD {{ element.TuitionAmount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="CommissionAmount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Commission Amount
        </th>
        <td mat-cell *matCellDef="let element">
          $ CAD {{ element.CommissionAmount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="CommissionStatusName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Commission Status
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.CommissionStatusName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Dispute">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Dispute</th>
        <td
          mat-cell
          *matCellDef="let element"
          (click)="$event.stopPropagation()"
        >
          <span
            class="disputeLink"
            [class.disabledLink]="
              element.CommissionStatusName == 'NotEligible' || commissionsLocked
            "
            (click)="
              !commissionsLocked &&
                onDispute(element.ApplicationID, element.CommissionStatusName)
            "
            >Dispute</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="12">
          <div
            class="application-element-detail"
            [@detailExpand]="element.isExpanded ? 'expanded' : 'collapsed'"
          >
            <span class="mat-column-select"></span>
            <span mat-subheader>
              <strong>Program:</strong> {{ element.ProgramDescription }}
              <strong>Campus:</strong> {{ element.ProgramCampus }}
              <strong>Country:</strong> {{ element.CountryName }}
              <span *ngIf="element.NotEligibleStatusName">
                <strong>Note:</strong> {{ element.NotEligibleStatusName }}
              </span>
            </span>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="table-row"
        [class.inner-tr]="row.CommissionStatusName == 'NotEligible'"
        (click)="getRecord(row)"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="application-detail-row"
      ></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
  </div>
</div>
